var wW;
var wH;
var wS = 1;
var wB;
$(function () {
  wW = window.innerWidth;
  wH = window.innerHeight;
  wS = $(window).scrollTop();
  wB = wS + wH;
  setSpMenu();
  //storeClick();
  ulSwitch();
  setAnnounce();
  setPcMenuAcordion();
});

$(window).on("load", function () {
  wW = window.innerWidth;
  wH = window.innerHeight;
  wS = $(window).scrollTop();
  wB = wS + wH;
  $("body").addClass("is-active");
  setScrollAnimation();
});

$(window).on("scroll", function () {
  wS = $(window).scrollTop();
  wB = wS + wH;
  setScrollAnimation();
});

$(window).resize(function () {
  wW = window.innerWidth;
  wH = window.innerHeight;
  wB = wS + wH;
});

function setScrollAnimation() {
  $('.animation').not('.animation-active').each(function (i) {
    var elemPos = $(this).offset().top;
    if (wS > elemPos - wH + 100) {
      $(this).addClass('animation-active').dequeue();
      $(this).delay(100 * i).queue(function () {
        $(this).addClass('animation-active').dequeue();
      });
    }
  });
}

function setSpMenu() {
  $("header .box-menu-switch a").on("click",function(){
    $("body").toggleClass("menu-is-active");
    $("html").toggleClass("no-scroll");
    $(".PageOverlay").toggleClass("is-active");
    $("#shopify-section-header header .box-main-menu-sp > .box-inner").height(wH)
    return false;
  });

  //メニュー内ONLINE STOREの開閉
  $("#menu-store-sp").on("click",function(){
    $("#box-store-sp").slideToggle()
    return false;
  });

  //ONLINE STORE以外の展開
  $("#shopify-section-header header .box-main-menu-sp .box-top ul li a[href='#']").on("click",function(){
    $(this).next("ul").slideToggle("300");
    return false;
  });
}

function setPcMenuAcordion(){
  $("#shopify-section-header header .box-main-menu ul li>a[href='#']").on("click",function(){
    $(this).next("ul").slideToggle("300");
    return false;
  });
}

function storeClick(){
  $("#shopify-section-header #menu-store").on("click",function(){
    var sotoreHeight = $("#shopify-section-header #box-store .box-inner").height();
    if($(this).hasClass('is-active')){
      $("#shopify-section-header #box-store").css("height","0");
      $(this).removeClass("is-active");
    }else{
      $("#shopify-section-header #box-store").css("height",sotoreHeight);
      $(this).addClass("is-active");
    }
    return false;
  });
}

function ulSwitch(){
  $(".ul-switch").on("click",function(){
    $(this).toggleClass("is-active");
    $(this).parent().next("ul").slideToggle().addClass("is-active");
    return false;
  });
}

function setAnnounce(){
  if(!$("body").hasClass('template-index') && $("body").hasClass('announce-is-active')){
    var announceHeight = $("#section-announcement").height()
    $(window).on("scroll", function () {
      if(wS>=announceHeight){
        $("body").addClass("announce-is-scroll")
      }else{
        $("body").removeClass("announce-is-scroll")
      }
    });
  }
}